import { History } from 'history';
import { AppUser } from 'Src/views/App/App';
import { ProgrammeBookingContentProps } from './ProgrammeBooking.contracts';
import {
  ProgrammeBookingInvitesResponse,
  ProgrammeBookingDraftPayload,
  ProgrammeBookingConfirmPayload
} from './ProgrammeBooking.types';

type Params = {
  user: AppUser;
  history: History;
  actorLabel: string;
  actorFallbackLabel: string;
  data: ProgrammeBookingInvitesResponse | null;
  isLoading: boolean;
  error?: string;
  onReload: () => Promise<void>;
  onDraftClub: (row: any, payload: ProgrammeBookingDraftPayload) => Promise<any>;
  onUndraftClub: (row: any, payload: ProgrammeBookingConfirmPayload) => Promise<any>;
  onUpdateAcceptedClub: (row: any, payload: ProgrammeBookingDraftPayload) => Promise<any>;
  onCancelAcceptedClub: (row: any, payload: ProgrammeBookingConfirmPayload) => Promise<any>;
  onConfirmProgramme: (payload: ProgrammeBookingConfirmPayload) => Promise<any>;
};

export function buildProgrammeBookingContentProps(params: Params): ProgrammeBookingContentProps {
  return {
    user: params.user,
    history: params.history,
    actorLabel: params.actorLabel,
    actorFallbackLabel: params.actorFallbackLabel,
    data: params.data,
    isLoading: params.isLoading,
    error: params.error,
    onReload: params.onReload,
    onDraftClub: params.onDraftClub,
    onUndraftClub: params.onUndraftClub,
    onUpdateAcceptedClub: params.onUpdateAcceptedClub,
    onCancelAcceptedClub: params.onCancelAcceptedClub,
    onConfirmProgramme: params.onConfirmProgramme
  };
}
